import { Stack, StackProps, styled } from '@mui/material';

const StyledStepperContentWrapper = styled(Stack)<StackProps>(() => ({
  height: 'calc(100vh - 8rem)',
  justifyContent: 'space-between'
}));

export default StyledStepperContentWrapper;
